import React, { useEffect } from 'react';
import ForgotPasswordForm from "./components/ForgotPasswordForm/ForgotPasswordForm";
import AnimatedBackground from '../../components/AnimatedBackground/AnimatedBackground';

import styles from './forgotPassword.module.scss';

const ForgotPassword = () => {
    return (
        <main className={styles.wrapper}>
            <AnimatedBackground />
            <ForgotPasswordForm />
        </main>
    );
};

export default ForgotPassword;